module.exports = __webpack_public_path__ + "img/service2.0fc39a72.webp";